import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-x",
  templateUrl: "./x.component.html",
  styleUrls: ["./x.component.scss"],
})
export class XComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
